var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:[_vm.$style.checkListItem, {'desktop-view': _vm.hasDesktopView}]},[_c('Icon',{attrs:{"icon":['fas', 'check-circle', '', _vm.color],"size":24}}),_c('div',[_vm._v(_vm._s(_vm.content))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }